<template>
  <div id="game-wrapper">
    <div id="title-screen" :class="{'active':showTitleScreen}"  @click="startGame" @touchstart="startGame">
      <img id="title-img" src="../src/assets/img/titel-bild.jpg">
      <img src="../src/assets/img/titel.jpg">
    </div>
    <div id="game" :class="{'active':showGame}">
      <img src="../src/assets/img/passionsaltar.jpg">
    </div>
    <div id="draggables" :class="{'active': showGame}">
      <div
        v-for='item in draggableItems'
        :key='item.id'
        :id="item.name"
        :class="{ 'active': item.active, draggable: true, dragged: item.dragged, placed: item.placed}"
        @touchstart='startDrag($event, item)'
        @mousedown='startDrag($event, item)'
        @touchend='dragEnd($event, item)'
        @mouseup='dragEnd($event, item)'
      >
        <img :src="require('@/assets/img/'+ item.name + '.png')" alt="item.name">
      </div>
    </div>
    <div
      v-for="item in dropableItems"
      :key="item.id"
      :id="item.name"
      :class="{'dropable': true, 'dropped': item.dropped}"
      @drop='onDrop($event, 1)'
      @dragover.prevent
      @dragenter.prevent
    ></div>
    <div class="message active" v-if="message" v-on:click="closeMessage">
      <div :class="{'popup': true, 'wide': widerMessage}">
        <p v-html="messageContent"></p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Passionsaltar',
  data () {
    return {
      $dragElement: null,
      dragItem: null,
      showTitleScreen: true,
      showGame: false,
      message: false,
      messageContent: '',
      widerMessage: false,
      messages: [
        { id: 0, html: '<b>Schau genau hin</b> und ordne die Gegenstände den Szenen oder Personen auf dem Altar zu!' },
        { id: 1, html: '<b>Das war sehr gut!</b> Du hast alle Dinge gefunden.' }
      ],
      draggableItems: [
        { id: 0, name: 'Gugel', html: 'Dies ist eine <b>Gugel</b>. Sie ist eine Art Kapuze mit einem Kragen über den Schultern. Meist war sie aus einfachem Wollstoff, aber für Reiche gab es sie auch aus teuren Stoffen oder sogar mit Pelzbesatz – wie hier auf dem Bild.', required: 'Gugel-Drop', active: true },
        { id: 1, name: 'Hahn', html: '<b>Der Hahn</b> kräht gerade – Jesus sagte voraus, dass sein Jünger Petrus ihn dreimal in der gleichen Nacht verleugnen wird, bevor der Hahn am Morgen kräht. Genau das passiert auch und Petrus bereut sehr, dass er nicht stark genug war, für seinen Glauben und Jesus einzutreten.', required: 'Hahn-Drop', active: false },
        { id: 2, name: 'Haube', html: 'Im Mittelalter mussten verheiratete Frauen ihre Haare mit einer <b>Haube</b> verdecken. Unverheiratete durften die Haare zeigen. Daher kommt der Ausdruck „unter die Haube“ kommen, wenn jemand heiratet.', required: 'Haube-Drop', active: false },
        { id: 3, name: 'Skorpion', html: '<b>Der Skorpion</b> wird oft als Zeichen für das Böse verwendet. Hier ist er auf der Flagge zu sehen und kennzeichnet die Gruppe der Feinde von Jesus.', required: 'Skorpion-Drop', active: false },
        { id: 4, name: 'Trippen', html: 'Im Mittelalter war es besonders bei reichen Personen Mode, Schuhe mit langen Spitzen zu tragen. Daher stammt der Ausdruck „auf großem Fuß leben“. Die Unterschuhe aus Holz heißen <b>Trippen</b>. Sie schützten die Füße zusätzlich gegen Kälte und Schmutz.', required: 'Trippen-Drop', active: false }
      ],
      dropableItems: [
        { id: 5, name: 'Gugel-Drop', dropped: false },
        { id: 6, name: 'Hahn-Drop', dropped: false },
        { id: 7, name: 'Haube-Drop', dropped: false },
        { id: 8, name: 'Skorpion-Drop', dropped: false },
        { id: 9, name: 'Trippen-Drop', dropped: false }
      ],
      placedItems: [],
      touchmoveEventListener: (evt) => { this.drag(evt) },
      touchendEventListener: (evt) => { this.dragEnd(evt) }
    }
  },
  methods: {
    startGame () {
      this.showTitleScreen = false
      this.showGame = true
      setTimeout(this.showMessage, 10, this.messages[0].html)
    },
    startDrag (evt, item) {
      evt.preventDefault()
      evt.stopPropagation()
      if (!this.placedItems.includes(item.id)) {
        this.$dragElement = evt.target
        if (this.$dragElement.nodeName === 'IMG') this.$dragElement = this.$dragElement.parentNode
        const box = this.$dragElement.getBoundingClientRect()
        const c = evt.type.match(/^touch/) ? evt.touches[0] : evt
        this.$dragElement.mouseOffset = { x: c.clientX - box.left, y: c.clientY - box.top }
        this.$dragElement.style.left = (c.clientX - this.$dragElement.mouseOffset.x - this.$el.offsetLeft) + 'px'
        this.$dragElement.style.top = (c.clientY - this.$dragElement.mouseOffset.y - this.$el.offsetTop) + 'px'
        this.$set(item, 'dragged', true)
        this.dragItem = item
        window.addEventListener(evt.type === 'mousedown' ? 'mousemove' : 'touchmove', this.touchmoveEventListener)
        window.addEventListener(evt.type === 'mousedown' ? 'mouseup' : 'touchend', this.touchendEventListener)
      }
    },
    drag (evt) {
      evt.preventDefault()
      evt.stopPropagation()
      if (this.$dragElement && this.$dragElement.mouseOffset) {
        const c = evt.type.match(/^touch/) ? evt.touches[0] : evt
        this.$dragElement.style.left = (c.clientX - this.$dragElement.mouseOffset.x - this.$el.offsetLeft) + 'px'
        this.$dragElement.style.top = (c.clientY - this.$dragElement.mouseOffset.y - this.$el.offsetTop) + 'px'
      }
    },
    dragEnd (evt) {
      if (this.dragItem) {
        const c = evt.type.match(/^touch/) ? evt.changedTouches[0] : evt
        const box = this.dragItem.required ? this.$el.querySelector('#' + this.dragItem.required).getBoundingClientRect() : null
        if (box) {
          const clickMargin = box.width / 4
          if (box.left < c.clientX && box.right - clickMargin > c.clientX && box.top < c.clientY && box.bottom > c.clientY) {
            this.onDrop()
            return
          }
        }
        this.resetDragElement()
        this.removeEventListeners()
        this.$dragElement = null
        this.dragItem = null
      }
    },
    onDrop () {
      if (this.dragItem) {
        this.showMessage(this.dragItem.html)
        this.draggableItems[this.placedItems.length].active = false
        this.placedItems.push(this.dragItem.id)
        for (var n = 0; n < this.dropableItems.length; n++) {
          if (this.dropableItems[n].name === this.dragItem.required) this.dropableItems[n].dropped = true
        }
        if (this.placedItems.length < this.draggableItems.length) this.draggableItems[this.placedItems.length].active = true
        this.$dragElement = null
        this.dragItem = null
      }
    },
    resetDragElement () {
      if (this.$dragElement) {
        this.$dragElement.style.zIndex = 'auto'
        this.$dragElement.style.left = null
        this.$dragElement.style.top = null
        this.$set(this.dragItem, 'dragged', false)
      }
    },
    removeEventListeners () {
      window.removeEventListener('mousemove', this.touchmoveEventListener)
      window.removeEventListener('touchmove', this.touchmoveEventListener)
      window.removeEventListener('mouseup', this.touchendEventListener)
      window.removeEventListener('touchend', this.touchendEventListener)
    },
    closeMessage () {
      this.message = false
      this.messageContent = ''
      if (this.placedItems.length === this.draggableItems.length) {
        this.placedItems.push('ende')
        this.showMessage(this.messages[1].html)
      }
    },
    showMessage (htmlText) {
      this.message = true
      this.widerMessage = htmlText.length > 150
      this.messageContent = htmlText
    }
  }
}
</script>
